import React from 'react';
import { readableDateFormat } from '../../components/shareFunctions';


export function renderUserDetailsCol(user_id, userList) {
    const userDetails = userList.find(({ _id }) => _id === user_id)

    if (!userDetails) return <p>{user_id}</p>

    return <>
        <strong style={{ textTransform: 'capitalize' }}>{userDetails.name}</strong>
        <br />
        <i style={{ opacity: '0.5' }}>{userDetails.email}</i>
    </>
}
const getUserName = (id, userList) => userList?.find(usr => usr._id === id)?.name

export function renderTemplateDetailsCol(template_id, templateList, userList) {
    const template = templateList.find(t => t._id === template_id)
    if (!template) return <p>{template_id}</p>

    return <div>
        <h6>{template.name}</h6>
        <p style={{
            opacity: '0.5',
        }}>{template?.subject}</p>
        <div style={{
            opacity: '0.5',
            fontSize: '0.75rem'
        }}>
            <div>
                <span style={{ textTransform: 'uppercase' }}>Last Update:
            </span>
                <i> {readableDateFormat(template.updatedAt)}</i>
            </div>
            <div style={{ padding: '0.2rem' }} />
            <div>
                <span style={{ textTransform: 'uppercase' }}>
                    Created By:
            </span>
                <i style={{ textTransform: 'capitalize' }}>{getUserName(template.user_id, userList)}</i>
            </div>
        </div>
    </div>
}